var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserdetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 171,
    viewBox: "0 0 193 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3187_27395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.077 149.134C101.077 149.134 101.502 150.187 102.366 151.835",
    stroke: "#22A081",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.552 157.034C110.735 164.38 120.549 173.714 135.645 170.258C157.049 165.359 146.597 148.075 139.935 153.738C130.871 161.449 149 172 163.5 156C174.5 142.5 175.5 134 175.5 124",
    stroke: "#22A081",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6758 83.5002V39.3022C52.6758 32.1309 58.4837 26.323 65.65 26.323H72.7364",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.377 26.323H132.459C139.625 26.323 145.438 32.1309 145.438 39.3022V136.16C145.438 143.326 139.625 149.139 132.459 149.139H65.65C58.4837 149.139 52.6758 143.326 52.6758 136.16V105",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0593 52.646C113.597 52.646 125.382 40.8608 125.382 26.323C125.382 11.7852 113.597 0 99.0593 0C84.5215 0 72.7363 11.7852 72.7363 26.323C72.7363 40.8608 84.5215 52.646 99.0593 52.646Z",
    fill: "white",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.222 126.282C181.252 126.282 192.626 114.908 192.626 100.877C192.626 86.8471 181.252 75.4733 167.222 75.4733C153.191 75.4733 141.817 86.8471 141.817 100.877C141.817 114.908 153.191 126.282 167.222 126.282Z",
    fill: "#22A081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.061 103.189C172.455 104.078 172.051 105.117 171.162 105.512L169.384 106.296C168.495 106.69 167.457 106.286 167.062 105.397L166.613 104.388C165.868 102.805 166.443 100.772 167.766 99.6987C169.214 98.7449 170.293 97.007 169.469 95.2891C167.801 91.8432 162.947 93.3764 163.087 96.7023C163.117 97.4215 162.702 98.0907 162.043 98.3803C161.474 98.63 160.795 98.9346 160.175 99.2093C159.097 99.6837 157.863 98.9896 157.713 97.826C157.384 95.2391 158.258 92.5424 160.081 90.6347C163.252 87.1739 169.125 87.0541 172.47 90.3401C176.221 93.6311 175.941 100.103 172.061 103.189ZM173.369 112.863C169.899 114.311 167.721 109.347 171.097 107.729C174.573 106.336 176.77 111.245 173.369 112.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.008 62.3993H70.0398C66.8337 62.3993 64.2368 64.9961 64.2368 68.2022C64.2368 71.4084 66.8337 74.0052 70.0398 74.0052H121.008C124.214 74.0052 126.811 71.4084 126.811 68.2022C126.816 64.9961 124.214 62.3993 121.008 62.3993Z",
    fill: "#22A081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.005 84.662H67.1383C65.5352 84.662 64.2368 85.9604 64.2368 87.5635C64.2368 89.1665 65.5352 90.4649 67.1383 90.4649H107.005C108.608 90.4649 109.906 89.1665 109.906 87.5635C109.906 85.9604 108.608 84.662 107.005 84.662Z",
    fill: "#535F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.005 104.019H67.1383C65.5352 104.019 64.2368 105.317 64.2368 106.92C64.2368 108.523 65.5352 109.822 67.1383 109.822H107.005C108.608 109.822 109.906 108.523 109.906 106.92C109.906 105.317 108.608 104.019 107.005 104.019Z",
    fill: "#535F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.005 123.38H67.1383C65.5352 123.38 64.2368 124.679 64.2368 126.282C64.2368 127.885 65.5352 129.183 67.1383 129.183H107.005C108.608 129.183 109.906 127.885 109.906 126.282C109.906 124.679 108.608 123.38 107.005 123.38Z",
    fill: "#535F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 106.393L32.9046 80.6585C33.146 80.1737 33.7013 79.9109 34.2506 80.0277L60.0478 85.4947C60.6876 85.629 61.104 86.2364 60.9773 86.8614C60.3315 89.9804 57.736 99.349 48.3684 112",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 114.605L1.02703 105C-1.23517 108.755 0.385868 113.623 4.45662 115.312L22.9655 123",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 138C45.8513 138 51 132.851 51 126.5C51 120.149 45.8513 115 39.5 115C33.1487 115 28 120.149 28 126.5C28 132.851 33.1487 138 39.5 138Z",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 126V132.562",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 122C41.1046 122 42 121.105 42 120C42 118.896 41.1046 118 40 118C38.8954 118 38 118.896 38 120C38 121.105 38.8954 122 40 122Z",
    fill: "#535F79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 105L44 110",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 97.0001L48 101",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 90.0001L51 95.0001",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.153 36.0614C109.262 37.9641 113.012 42.6634 113.547 48.2965C109.392 51.0482 104.413 52.6462 99.0544 52.6462C93.6959 52.6462 88.717 51.0482 84.562 48.2965C85.0964 42.6634 88.8468 37.9641 93.9556 36.0614",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0594 37.6245C104.074 37.6245 108.138 33.5597 108.138 28.5455C108.138 23.5313 104.074 19.4666 99.0594 19.4666C94.0453 19.4666 89.9805 23.5313 89.9805 28.5455C89.9805 33.5597 94.0453 37.6245 99.0594 37.6245Z",
    stroke: "#535F79",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3187_27395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192.626,
    height: 171,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserdetails);
export default __webpack_public_path__ + "static/media/userdetails.fb09f793709cd1e3d17d32e6e778ef1a.svg";
export { ForwardRef as ReactComponent };